import { Dispatch } from "redux";
import { MultiLanguageWrapper } from "@iddataweb/idw-common-ui/types";
import { AxnCompany } from "@idw-types/data/reference-data/axn";
import { addEmailTemplate } from "@redux/actions/email-templates-actions";
import { displaySuccessModal, logAndDisplayErrorModal } from "@utils/app-alert-util";
import { resources } from "@constants/hardcoded-strings";
import { EmailTemplate } from "@idw-types/data/email-template";
import { addObjectsToArrayInCommonReferenceData } from "@redux/actions/common-reference-data-actions";
import { createEmailTemplateRequest } from "@requests/axnadmin-core/create-email-template";
import { v4 as uuidv4 } from "uuid";
import { formatEmailTemplate } from "@formatters/email-templates/email-template-formatter";

export const createEmailTemplateReduxRequest = (dispatch: Dispatch) => async (
    template: string,
    name: string,
    companyId: string,
    sender: string,
    languages: Partial<MultiLanguageWrapper<string>>,
    axnCompanies: Array<AxnCompany>,
    addToReferenceData: boolean
): Promise<EmailTemplate> => {
    const { data, error, body } = await createEmailTemplateRequest(
        template,
        name,
        companyId,
        languages,
        sender
    );

    if (data) {

        const emailTemplate: EmailTemplate = {
            organizationID: data?.response.organizationID,
            rpServiceID: data?.response.rpServiceID,
            id: data?.response.id,
            template: data?.response.template,
            sender: data?.response.sender,
            languages :data?.response.languages,
            name: data?.response.name,
            status: data?.response.status,
            permissions: {
                canModify: true,
                canView: true,
                canCreate: true,
            },
            uuid: uuidv4(),
        };

        if (addToReferenceData) {
            dispatch(addObjectsToArrayInCommonReferenceData([emailTemplate], "emailTemplate"));
        } else {
            const formattedEmailTemplate = formatEmailTemplate(
                emailTemplate,
                axnCompanies,
            );
            dispatch(addEmailTemplate(formattedEmailTemplate));
        }

        displaySuccessModal(
            dispatch,
            resources.requests.createEmailTemplate.success.title,
            resources.requests.createEmailTemplate.success.message
        );
        return data?.response;
    } else if (error) {
        logAndDisplayErrorModal(
            dispatch,
            error,
            resources.requests.createEmailTemplate.error.title,
            resources.requests.createEmailTemplate.error.message,
            null,
            null,
            body
        );
    }

    return null;
};